import { REMOTE_CONFIG_KEYS, withRemoteConfigKey } from 'packages/utils';

import { MENU_PATHS } from '../constants';
import Attendance from './screens/Attendance';
import WorkingDay from './screens/WorkingDay';
import Holidays from './screens/Holidays';
import Modifications from './screens/Modifications';
import Incidents from './screens/Incidents';
import Hash from './screens/Hash';
import ActiveEnterprises from './screens/ActiveEnterprises';

import { ReportProvider } from './contexts/ReportContext';

const routes = [
  {
    component: () => <Attendance />,
    path: MENU_PATHS.ATTENDANCE_REPORT,
    exact: true,
    onOrgChangeRedirectTo: '/:orgId/-',
  },
  {
    component: () => <WorkingDay />,
    path: MENU_PATHS.DAILY,
    exact: true,
    onOrgChangeRedirectTo: '/:orgId/-',
  },
  {
    component: () => <Holidays />,
    path: MENU_PATHS.HOLIDAYS,
    exact: true,
    onOrgChangeRedirectTo: '/:orgId/-',
  },
  {
    component: () => <Modifications />,
    path: MENU_PATHS.MODIFICATIONS,
    exact: true,
    onOrgChangeRedirectTo: '/:orgId/-',
  },
  {
    component: () => <ActiveEnterprises isActive={true} />,
    path: MENU_PATHS.ACTIVE_ENTERPRISES,
    exact: true,
    onOrgChangeRedirectTo: '/:orgId/-',
  },
  {
    component: () => <ActiveEnterprises isActive={false} />,
    path: MENU_PATHS.INACTIVE_ENTERPRISES,
    exact: true,
    onOrgChangeRedirectTo: '/:orgId/-',
  },
  {
    component: () => <Incidents />,
    path: MENU_PATHS.ISSUES,
    exact: true,
    onOrgChangeRedirectTo: '/:orgId/-',
  },
  {
    component: () => <Hash />,
    path: MENU_PATHS.HASH,
    exact: true,
    onOrgChangeRedirectTo: '/:orgId/-',
  },
];

export default withRemoteConfigKey(REMOTE_CONFIG_KEYS.TIME_TRACKER, routes);
